import styles from "./Breadcrumbs.module.scss";

export const Breadcrumbs = ({ items, separator = "/" }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav aria-label="breadcrumb" className={styles.breadcrumbs}>
      <ol className={styles.breadcrumbs__list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={item.id || index} className={styles.breadcrumbs__item}>
              {!isLast && item.href ? (
                <a href={item.href} className={styles.breadcrumbs__link}>
                  {item.label}
                </a>
              ) : (
                <span
                  className={styles.breadcrumbs__current}
                  aria-current="page"
                >
                  {item.label}
                </span>
              )}

              {!isLast && (
                <span
                  className={styles.breadcrumbs__separator}
                  aria-hidden="true"
                >
                  &nbsp;{separator}&nbsp;
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
